// base url
if (location.hostname == 'localhost' || location.hostname == 'localhost:8888') {
	var path = '/mamabw/';
} else {
	var path = '/';
}

var import_data = $.ajax({ type: 'GET',   
                        url: path+'data.json',   
                        async: false
                      }).responseText;
var define = JSON.parse(import_data)[0];

var token = $('html').attr('token');

$(document).ready(function() {
	if($('.tinymce').length > 0) {
		// init tinyMCE
		var hash = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
		var target = hash[0].split('=');
		var section = target[1].substring(0, 4);

		tinymce.init({
			selector: '.tinymce',
			plugins: "autoresize link image media lists advlist code help paste table",
			paste_as_text: true,
			autoresize_bottom_margin: 20,
	      	autoresize_overflow_padding: 5,
			branding: false,
			menubar:false,
			statusbar: false,
			toolbar: "undo redo | formatselect | bold italic underline forecolor fontsizeselect | alignleft aligncenter alignright alignjustify | table | bullist numlist outdent indent | removeformat | link media image | code | help",
			image_title: true,
			automatic_uploads: true,
			file_picker_types: 'image',
			file_picker_callback: function (cb, value, meta) {
				var input = document.createElement('input');
				input.setAttribute('type', 'file');
				input.setAttribute('accept', 'image/*');
				input.setAttribute('name', 'img_cont');

				input.onchange = function () {

					$('.tox-dialog').prepend('<div id="loader"><div id="spinner"></div></div>');

					var file = this.files[0];

					var reader = new FileReader();
					reader.onload = function () {

						var id = 'blobid' + (new Date()).getTime();
						var blobCache =  tinymce.activeEditor.editorUpload.blobCache;
						var base64 = reader.result.split(',')[1];
						var blobInfo = blobCache.create(id, file, base64);
						blobCache.add(blobInfo);

						var file_input = $(input).prop('files')[0];
						var formData = new FormData();
						formData.append('file', file_input);
						formData.append('section', section);

						$.ajax({
							url: 'filebrowser.php',
							dataType: 'json',  
							cache: false,
							contentType: false,
							processData: false,
							data: formData,                         
							type: 'post',
							success: function(response){

								$('.tox-dialog #loader').hide();
								
								if (response.action == "bad_ext"){
									toastr.error("Invalid extension file (accept .jpg, .jpeg, .png, .gif)");
								}
								else if (response.action == "copy_failed") {
									toastr.error("The pictures could not be copied");
								}
								else if (response.action == "success") {

									cb(response.img_path, { 
										alt: file.name,
										title: file.name
									});

								}
							}
						});

					};
					reader.readAsDataURL(file);
				};
				input.click();
			}
		});
	}

	// init toastr
	toastr.options = {
		"closeButton": true,
		"debug": false,
		"newestOnTop": false,
		"progressBar": false,
		"positionClass": "toastr-top-right",
		"preventDuplicates": true,
		"onclick": null,
		"showDuration": "300",
		"hideDuration": "1000",
		"timeOut": "2000",
		"extendedTimeOut": "1000",
		"showEasing": "swing",
		"hideEasing": "linear",
		"showMethod": "fadeIn",
		"hideMethod": "fadeOut"
	}

	// ini flatpicker
	$(".datepicker").flatpickr({
		'locale' : {
			format: 'DD/MM/YYYY',
	    	"firstDayOfWeek": 1 // start week on Monday
		}
	});	

	$(".datetimepicker").flatpickr({
	    enableTime: true,
		dateFormat: "d-m-Y H:i",
		time_24hr: true,
		minuteIncrement: 15,
		'locale' : {
	    "firstDayOfWeek": 1 // start week on Monday
		}
	});

	// init Date range picker
	$(".rangepicker").daterangepicker({
		autoApply: true,
		locale: {
			format: 'DD/MM/YYYY',
    		firstDay: 1
    	}
	});

	// ini max length counter
	$('.counter').maxlength({
	    warningClass: "badge badge-success",
	    limitReachedClass: "badge badge-danger"
	});

	// init datatable
	/*if($('body').find('.data-table').length>0) {
		//var language = $('html').attr('lang');
		$('.data-table').DataTable({
			responsive: true,
			fixedHeader: {
				header: false,
				footer: true
			},
           "pageLength": 25,
           "aaSorting": []
      });

		$.fn.dataTable.moment = function ( format, locale ) {
			var types = $.fn.dataTable.ext.type;
			
		    // Add type detection
		    types.detect.unshift( function ( d ) {
		    	return moment( d, format, locale, true ).isValid() ?
		    	'moment-'+format :
		    	null;
		    } );
		    
		    // Add sorting method - use an integer for the sorting
		    types.order[ 'moment-'+format+'-pre' ] = function ( d ) {
		    	return moment( d, format, locale, true ).unix();
		    };
		};

		$.fn.dataTable.moment( 'DD-MM-YYYY' );
	}





	function table_order(path, folder) {
		if($('body').find('.data-table-'+folder+'-order').length>0) {
	        var table = $('.data-table-'+folder+'-order').DataTable({
	            rowReorder: true,
	            "pageLength": 25
	        });

	        table.on( 'row-reorder', function ( e, diff, edit ) {

		        var order_arr = new Array;	

		        $('.data-table-'+folder+'-order tbody tr').each(function() {
		        	order_arr.push($(this).data('id'));
		        });

		        $.post(path+'administration/request/xhr/'+folder+'/order.php', {order_arr: order_arr, token: token}, function(response) {
		        }, 'json');
		    } );
		}
	}*/

	// personnalise les datas à transmettre en dehors d'un serializeArray() dans la fonction xhr_send()
	function xhr_data(file = null, data, $this) {
		switch(file) {
			case 'content/get-image':
		    	data[data.length] = { name: 'id', value: $this.data('id') };
		    	data[data.length] = { name: 'folder', value: $this.data('folder') };
		    	break;

		    case 'content/select-image':
		    	data[data.length] = { name: 'id', value: $this.data('id') };
		    	data[data.length] = { name: 'uniqid', value: $this.closest('#file-result').data('id') };
		    	break;

		    case 'files/get-file' :				
		    	data[data.length] = { name: 'id', value: $this.data('id') };
		    	break;

	       	case 'ticket/get-ticket' :
	       		var id = $this.closest('[data-id]').data('id');
		    	data[data.length] = { name: 'id', value: id };
	       		break;

		    default:
		    	return true;
	    }
	}

	// personnalise les callback en cas de succès dans la fonction xhr_send()
	function xhr_success(callback = null, response, data, path) {
		var dataObj = {};
		for (i = 0; i < data.length; i++) {
			dataObj[data[i].name] = data[i].value;
		}

		switch(callback) {
			case 'settings/update-keys':
				if(dataObj['id'] != '') {
					$('tr[data-id='+dataObj['id']+'] .dev').html(dataObj['dev']);
					$('tr[data-id='+dataObj['id']+'] .prod').html(dataObj['prod']);
					if(dataObj['public'] == 1) {
						$('tr[data-id='+dataObj['id']+'] .public').html('<i class="fa fa-check text-success"></i>');
					}
					else {
						$('tr[data-id='+dataObj['id']+'] .public').html('<i class="fa fa-times text-danger"></i>');
					}
				}
				else {
					setTimeout(function() {
						location.reload();
					}, 3000);
				}
				toastr.success(response.msg);
				$('#modal-keys').modal('hide');
		    	break;

		    case 'keyword/update-keyword':
		    	toastr.success(response.msg);
				$('#modal-keyword').modal('hide');

		    	if($('[data-id='+dataObj['id_keyword']+']').length > 0) {
					$.each(dataObj, function( index, value ) {
						if(index != 'id_keyword' && index != 'token' && index != 'public') {
							$('[data-id='+dataObj['id_keyword']+'] .'+index).html(value);
						}					
					});

			    	if(dataObj['public'] == 1) {
						$('tr[data-id='+dataObj['id_keyword']+'] .public').html('<i class="fa fa-check text-success"></i>');
					}
					else {
						$('tr[data-id='+dataObj['id_keyword']+'] .public').html('<i class="fa fa-times text-danger"></i>');
					}
				}
				else {
					location.reload();
				}
		    	break;
		    case 'content/get-image':
		    	$('#modal-get-image .modal-body').html(response.html);
		    	filemanager_dropzone(path, 'content-manager');
		    	if(!$('#modal-get-image').is(':visible')) {
			    	$('#modal-get-image').modal('show');
		    	}
		    	break;

	    	case 'content/select-image':
		    	$('#modal-get-image').modal('hide');
		    	$('#preview-'+response.uniqid).html(response.html);
		    	$('#preview-'+response.uniqid).closest('[data-hook]').find('input[name=image]').val(response.id)
		    	break;

		    case 'files/get-file' :
		    	$('#modal-update-file').modal('show');
				$('#modal-update-file .modal-title span').html(response.file.filename);

				var form = '#modal-update-file #form-update-file';
				$(form).find('input').val('');

				$.each(response.file, function(i, item) {
					if($(form).find('#'+i).prop('tagName') == 'INPUT') {
				    	$(form).find('#'+i).val(item);
				    }
				    else {
						$(form).find('#'+i).text(item);
				    }
				});

				$('#modal-update-file #download').attr('href', response.file.link);

				$('#modal-update-file #alt').addClass('d-none');
				$('#modal-update-file #dimension').addClass('d-none');
				$('#modal-update-file #delete-file').data('id', response.file.id);

				$('#modal-update-file #preview').removeClass('light dark');
				$('#modal-update-file #preview').addClass('light');

				$('#modal-update-file [data-mode]').removeClass('d-none');
				$('#modal-update-file [data-mode=light]').addClass('d-none');

				if(response.file.type == 'image') {
					$('#modal-update-file #alt').removeClass('d-none');
					$('#modal-update-file #dimension').removeClass('d-none');
					$('#modal-update-file #preview').html('<img src="/dist/assets/img/'+response.file.path+response.file.filename+'" class="mh-100 mw-100">');
				}
				else if(response.file.type == 'video') {
					$('#modal-update-file #preview').html('<video controls id="video-preview" style="width: 100%; height: 100%; margin:0 auto; frameborder:0;"><source src="" type="video/mp4">Your browser doesn\'t support HTML5 video tag.</video>');

					$('#modal-update-file').find('source').attr('src', '/dist/assets/img/'+response.file.path+response.file.filename+ '?autoplay=1&amp;modestbranding=1&amp;showinfo=0');
					$('#video-preview')[0].load();
					$('#modal-update-file').modal('show');
					// $('#video-preview')[0].play();
					$('#video-preview').prop('muted', true);

					$('#modal-update-file').on('hidden.bs.modal', function () {
						$('#video-preview')[0].pause();
					});
				}
				else if(response.file.ext.toLowerCase() == 'pdf') {
					$('#modal-update-file #preview').html('<iframe src="/dist/assets/img/'+response.file.path+response.file.filename+'" class="h-100 w-100"></iframe>');
				}
				else{
					$('#modal-update-file #preview').html('<i class="fa-duotone fa-file fa-2xl text-primary"></i>');
				}

				break;

			case 'ticket/get-default-ticket' :
				$('#modal-ticket input[type="text"]').val('');

				$.each(response.ticket, function(key, value) {
					$('#modal-ticket #' + key).val(value);
				});
					
				$('#modal-ticket #bug').prop('checked', false);

				$('#modal-ticket [data-control="select2"]').trigger('change.select2'); 

				$('#modal-ticket').modal('show'); 

				break;

			case 'ticket/get-ticket' :
				$('#modal-ticket input[type="text"]').val('');

				$.each(response.ticket, function(key, value) {
					$('#modal-ticket #' + key).val(value);
				});

				if(response.ticket.bug == 1) {					
					$('#modal-ticket #bug').prop('checked', true);
				}
				else {
					$('#modal-ticket #bug').prop('checked', false);
				}


				$('#modal-ticket .ticket-nbr').html('#'+response.ticket.id);

				$('#modal-ticket [data-control="select2"]').trigger('change.select2'); 

				$('#modal-ticket').modal('show'); 

				break;

			case 'ticket/last-seen' :
				$('#last-seen-bullet').remove();
				break;

			default:
				return true;
		}

	}

	// fonction principale pour l'envoie et le controle de requêtes ajax
	function xhr_send(path, token, $this) {
		var file = $this.data('xhr');
		
		if($this.prop('tagName') == 'BUTTON' && $this.is('[data-kt-indicator]')) {
			var loading = true;
			var text = $this.find('.indicator-label').html();
		}else {
			var laoding = false;
		}

		if($this.data('type') !== undefined) {
			var type = $this.data('type');
		}
		else {
			var type = null;
		}
		var form = '#'+$this.closest('form').attr('id');

		if(type == 'delete') {
			var id = $this.closest('[data-id]').data('id');

			Swal.fire({
                text: "Êtes-vous certain de vouloir supprimer cet enregistrement ?",
                icon: "warning",
                showCancelButton: true,
                buttonsStyling: false,
                confirmButtonText: "Oui, supprimez-le !",
                cancelButtonText: "Non, retour",
                customClass: {
                    confirmButton: "btn btn-primary",
                    cancelButton: "btn btn-active-light"
                }
            }).then(function (result) {
                if (result.value) {
                    $.post(path+'administration/request/xhr/'+file+'.php', { id: id, token: token }, function(response, statusText, jqXHR) {
						if(response.action == 'success') {

							if(response.callback === true) {
								xhr_success(file, response, data, path);
							}
							else {
								if(response.msg != null) {
									toastr.success(response.msg);
								}
								$this.closest('[data-id]').remove()					
							}

							if(response.url != null) {
								if(response.msg != null) {								
									setTimeout(function() {
										if(response.url == 'reload') {
											location.reload();
										}
										else {
											location.href = response.url;
										}
									}, 1500);
								}
								else {
									if(response.url == 'reload') {
										location.reload();
									}
									else {
										location.href = response.url;
									}
								}
							}
						}
						else if(response.action == 'empty') {
							if(response.msg != null) {
								toastr.warning(response.msg);
							}
						}
						else if(response.action == 'token') {
							location.reload();
						}   
						else {
							if(response.msg != null) {
								toastr.error(response.msg);
							}
							$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', debug:true, token: token}, function(response2) {}, 'json');
						}
					}, 'json')
					.always(function(jqXHR) {
					    if(jqXHR.status == 404) {
							$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', token: token}, function(response2) {}, 'json');
					    }
					    else if(jqXHR.status == 500) {			    	
							toastr.error('Request error. Please contact the support');

							$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'admin', token: token}, function(response2) {}, 'json');
					    }
					});
                }
            });
		}
		else {
			var data = $(form).serializeArray();
			data[data.length] = { name: 'token', value: token };

			$('.tinymce').each(function() {
				var currentEditorId = $(this).attr('id');
				var val = tinyMCE.get($(this).attr('id')).getContent();

				for (index = 0; index < data.length; ++index) {
				    if (data[index].name == currentEditorId) {
				        data[index].value = val;
				    }
				}
			});

			xhr_data(file, data, $this);

			$('.is-invalid').removeClass('is-invalid');
			$.post(path+'administration/request/xhr/'+file+'.php', data, function(response, statusText, jqXHR) {
				if(response.action == 'success') {
					if(response.callback === true) {
						xhr_success(file, response, data, path);
					}
					else {
						if(response.msg != null) {
							toastr.success(response.msg);						
						}
					}

					if(response.url != null) {
						if(response.msg != null) {								
							setTimeout(function() {
								if(response.url == 'reload') {
									location.reload();
								}
								else {
									location.href = response.url;
								}
							}, 1500);
						}
						else {
							if(response.url == 'reload') {
								location.reload();
							}
							else {
								location.href = response.url;
							}
						}
					}
				}
				else if(response.action == 'empty') {
					if(response.msg != null) {
						toastr.warning(response.msg);
					}

					$.each(response.fields, function(i, item) {
					    $(form).find('#'+item).addClass('is-invalid');
					});
				}
				else if(response.action == 'token') {
					location.reload();
				}
				else {
					if(response.msg != null) {
						toastr.error(response.msg);
					}

					$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'admin', debug:true, token: token}, function(response2) {}, 'json');
				}

				if(loading == true) {
					setTimeout(function() {				        
						$this.attr("data-kt-indicator", "off");
						$this.html(text.replace('Please wait...', ''));
				    }, 300);
				}

			}, 'json')
			.always(function(jqXHR) {
			    if(jqXHR.status == 404) {
					$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', token: token}, function(response2) {}, 'json');
					location.href = 'index.php';
			    }
			    else if(jqXHR.status == 500) {			    	
					toastr.error('Request error. Please contact the support');

					$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'admin', token: token}, function(response2) {}, 'json');
			    }
			});
		}
	}

	// bind un click sur les éléments portant le [data-xhr]
	$(document).on('click', '[data-xhr]', function(e) {
		var $this = $(this);

		if(!$this.is(':checkbox')) {
			e.preventDefault();
		}

		if($this.prop('tagName') == 'BUTTON') {
			var text = $this.text();

			$this.html('<span class="indicator-label">'+text+'</span><span class="indicator-progress">Please wait... <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>');		
			$this.attr("data-kt-indicator", "on");
		}

		xhr_send(path, token, $this);
	});

	$('.delete').click(function(e){
		if (confirm('Voulez-vous vraiment supprimer ceci?')) {
			$(this).next('form').submit();
		}
		e.preventDefault();
	});

	$(document).on('click', '.test', function(e) {
		e.preventDefault();
    	$.get(path+'administration/template/section/_builder.php', {id: '12'}, function(response) {
    		$('#section_target').append(response.replace('[rel]', ''));
    		// $('#section-modal').modal('toggle');
    		$("html, body").animate({ scrollTop: $(document).height() }, 1000);

			$.get(path+'administration/template/section/control/code.php', function(response) {
	    		$('#editor').parent().html(response.replace('[content]', ''));
	    		
	    	});

    	});    		
    });
    // ajout et construction d'une section
    $(document).on('click', '.line', function() {
    	var id = $(this).attr('id').split('_')[1];
    	$.get(path+'administration/template/section/_builder.php', {id: id}, function(response) {
    		$('#section_target').append(response.replace('[rel]', ''));
    		$('#section-modal').modal('toggle');
    		$("html, body").animate({ scrollTop: $(document).height() }, 1000);
    	});    		
    });

    // ajout et construction d'une section
    $(document).on('click', '#section_target section', function() {
    	$('#section_target section').removeClass('active');
    	$(this).addClass('active');
    	$('.section-option').slideDown('fast');

    	// ajuster le checkbox fluid
    	if($(this).find('.control').hasClass('class_fluid')) {
    		$('.section-option').find('#fluid').prop('checked', true);
    	}
    	else {
    		$('.section-option').find('#fluid').prop('checked', false);
    	}

    	$('.section-option').find('#id_class').val($(this).find('.control').attr('rel'));
    });

    $(document).on('click', '.close-section', function () {
    	$('#section_target section').removeClass('active');
    	$(".section-option").slideUp('fast');
    });

    $(document).on('click', '#fluid', function () {
    	if($(this).is(':checked')) {
    		$('section.active .control').addClass('class_fluid');
    	}
    	else {			
    		$('section.active .control').removeClass('class_fluid');
    	}
    });

    $(document).on('change', '#id_class', function () {
    	var val = $(this).val();
    	$('section.active .control').attr('rel', val);
    });

    $(document).on('click', '#editor button', function(e) {  
    	var $this= $(this);  	
    	var type = $(this).data('type');

    	$.get(path+'administration/template/section/control/'+type+'.php', function(response) {
    		$this.closest('#editor').parent().html(response.replace('[content]', ''));
    		if(type == 'text') {
    			tinymce.init({
    				selector: '.tinymce',
    				plugins: "autoresize link lists advlist code",
    				autoresize_bottom_margin: 20,
    				branding: false,
    				menubar:false,
    				statusbar: false,
    				toolbar: "undo redo | formatselect | bold italic underline forecolor fontsizeselect | alignleft aligncenter alignright alignjustify | table | bullist numlist outdent indent | removeformat | link media image | code | help"
    			});
    		}
    	});

    	e.preventDefault();
    });

    $(document).on('submit', '#form_image', function(e) {
    	$this = $(this);
    	var formData = new FormData(this);
    	formData.append("type", "img");

    	$.ajax({
    		url: path+"administration/request/xhr/upload/upload.php?input=image&folder=content%2F",
    		type: "POST",
    		data:  formData, 
    		dataType: 'json',
    		contentType: false,
    		cache: false,
    		processData:false,
    		beforeSend : function()
    		{
			//$("#preview").fadeOut();
			$("#err").fadeOut();
		},
		success: function(response)
		{				

			var filename = response.filename;
			var ext = response.ext;
			var id = response.id;
			$.get(path+'administration/template/section/template/img.php', function(data) {
				$this.find('.preview').html(data.replace('[src]', '../dist/assets/files/content/'+ filename+'_md.'+ext).replace('[id]', id));

						//'<img src="../files/'+ response.filename+'_m.'+response.ext+'" class="img-fluid" /><input name="img" type="hidden" value="'+response.id+'" />');
					});

				//$this.closest('[data-type]').find('.preview').html('<img src="../files/'+ response.filename+'_m.'+response.ext+'" class="img-fluid" /><input name="img" type="hidden" value="'+response.id+'" />');
			},
			error: function(e) 
			{
				toastr.error(response.msg);
			}          
		});


    	e.preventDefault();
    	return false;
    });

    // ajout d'une image dans le hook depuis la librairie media
    $(document).on('click', '.choose-pic', function(e) {
    	var id = $(this).data('pic');
    	var src = $(this).attr('rel');

    	$(this).closest('[data-type]').find('input[name="img"]').val(id);
    	$(this).closest('[data-type]').find('.preview img').attr('src', src);

    	$('#choose-pic-modal').modal('toggle');
    });

    $('.custom-file-input').on('change', function() {
    	let fileName = $(this).val().split('\\').pop();
    	$(this).siblings('.custom-file-label').addClass('selected').html(fileName);
    });

    $(document).on('submit', '#form_file', function(e) {
    	$this = $(this);

    	$.ajax({
    		url: path+"administration/request/xhr/content/upload.php",
    		type: "POST",
    		data:  new FormData(this), 
    		dataType: 'json',
    		contentType: false,
    		cache: false,
    		processData:false,
    		beforeSend : function()
    		{
			//$("#preview").fadeOut();
			$("#err").fadeOut();
		},
		success: function(response)
		{	
			location.reload();
		},
		error: function(e) 
		{
			toastr.error(response.msg);
		}          
	});


    	e.preventDefault();
    	return false;
    });

	// save template et contenu
	$(document).on('click', '#update-content', function(e) {
		var page = $('input[name=page]').val();	
		var lang = $('input[name=lang]').val();
		var menu_title = $('input[name=menu_title]').val();
		var admin_title = $('input[name=admin_title]').val();

		if($("#Online_page").is(':checked')) {
			var show = 1;
		}
		else {
			var show = 0;
		}

		if($("#secure_login").is(':checked')) {
			var secure_login = 1;
		}
		else {
			var secure_login = 0;
		}	

		if($("#secure").is(':checked')) {
			var secure = 1;
		}
		else {
			var secure = 0;
		}	

		if($("#Menu_visible").is(':checked')) {
			var menu = 1;
		}
		else {
			var menu = 0;
		}

		var menu_id = $('#Menu_id').val();	

		var structure = [];
		var content = [];
		var type = [];
		var val = [];
		var hook = [];
		var fluid = [];
		var add_class = [];
		var i = 0;
		
		$('#section_target section').each(function() {
			structure[i] = $(this).attr('id').split('_')[1];

			// gestion class fluid
			if($(this).find('.control').hasClass('class_fluid')) {
				fluid[i] = 1;
			}
			else {
				fluid[i] = 0;
			}

			// ajout de class/id
			if($(this).find('.control').attr('rel') !== undefined) {
				add_class[i] = $(this).find('.control').attr('rel');
			}
			else {
				add_class[i] = 'null';	 		
			}

			console.log(add_class[i]);
			
			var type_section = [];
			var val_section = [];
			var j = 0;
			$('div[data-type]', this).each(function() {
				type_section[j] = $(this).data('type');
				type[i] = type_section;

				if($(this).data('type') == 'code') {
					var $this = $(this);
					var hook_section = [];

					$('div[data-hook]', this).each(function(index) {
						if($(this).data('hook') == 'text') {
							var currentEditorId = $(this).find('.tinymce').attr('id');							
							hook_section.push(tinyMCE.get(currentEditorId).getContent());
						}
						else {
							var val = $(this).find('input[name="img"], input[name="video"]').val();
							hook_section.push(val);
							//hook_section.push($(this).val());
						}
					});

					hook[i] = hook_section;
				}

				if($(this).data('type') == 'text') {
					var currentEditorId = $(this).find('.tinymce').attr('id');
					var val = tinyMCE.get(currentEditorId).getContent();
				}
				else {
					var val = $(this).find('input[type="text"], input[type="search"], input[type="hidden"]').val();
					console.log('hidden'+val);
				}
				val_section[j] = val;
				content[i] = val_section;
				j++;
			});

			i++;
		});
		if( $('#Id_page_content').length > 0 ){
			var Id_page_content = $('#Id_page_content').val();
		} else {
			var Id_page_content = "none";
		}
		$.post(path+'administration/request/xhr/content/add_section.php', { 
			page: page, 
			lang: lang, 
			menu_title: menu_title,
			admin_title: admin_title,
			show: show, 
			menu: menu, 
			menu_id: menu_id, 
			type: type, 
			structure: structure, 
			content: content, 
			hook: hook,
			fluid: fluid,
			add_class: add_class,
			secure_login: secure_login,
			secure: secure,
			Id_page_content: Id_page_content,
			token: token
		}, function(response) {
			if(response.action=='success') {
				toastr.success(response.msg);
			}
			else if(response.action == 'token') {
				location.reload();
			}			
			else {
				toastr.error(response.msg);
			}
		}, 'json');

		e.preventDefault();
	});

    // save template et contenu
    $(document).on('click', '#save-content', function(e) {
    	var page = $('input[name=page]').val();	
    	var lang = $('input[name=lang]').val();
    	var menu_title = $('input[name=menu_title]').val();
    	var admin_title = $('input[name=admin_title]').val();

    	if($("#Online_page").is(':checked')) {
    		var show = 1;
    	}
    	else {
    		var show = 0;
    	}

    	if($("#secure_login").is(':checked')) {
    		var secure_login = 1;
    	}
    	else {
    		var secure_login = 0;
    	}	

    	if($("#secure").is(':checked')) {
    		var secure = 1;
    	}
    	else {
    		var secure = 0;
    	}	

    	if($("#Menu_visible").is(':checked')) {
    		var menu = 1;
    	}
    	else {
    		var menu = 0;
    	}

    	var menu_id = $('#Menu_id').val();	

    	var structure = [];
    	var content = [];
    	var type = [];
    	var val = [];
    	var hook = [];
    	var fluid = [];
    	var add_class = [];
    	var i = 0;
    	
    	$('#section_target section').each(function() {
    		structure[i] = $(this).attr('id').split('_')[1];

	 		// gestion class fluid
	 		if($(this).find('.control').hasClass('class_fluid')) {
	 			fluid[i] = 1;
	 		}
	 		else {
	 			fluid[i] = 0;
	 		}

	 		// ajout de class/id
	 		if($(this).find('.control').attr('rel') !== undefined) {
	 			add_class[i] = $(this).find('.control').attr('rel');
	 		}
	 		else {
	 			add_class[i] = 'null';	 		
	 		}

	 		console.log(add_class[i]);
	 		
	 		var type_section = [];
	 		var val_section = [];
	 		var j = 0;
	 		$('div[data-type]', this).each(function() {
	 			type_section[j] = $(this).data('type');
	 			type[i] = type_section;

	 			if($(this).data('type') == 'code') {
	 				var $this = $(this);
	 				var hook_section = [];

	 				$('div[data-hook]', this).each(function(index) {
	 					if($(this).data('hook') == 'text') {
	 						var currentEditorId = $(this).find('.tinymce').attr('id');							
	 						hook_section.push(tinyMCE.get(currentEditorId).getContent());
	 					}
	 					else {
	 						var val = $(this).find('input[name="img"], input[name="video"]').val();
	 						hook_section.push(val);
	 					}
	 				});

	 				hook[i] = hook_section;
	 			}

	 			if($(this).data('type') == 'text') {
	 				var currentEditorId = $(this).find('.tinymce').attr('id');
	 				var val = tinyMCE.get(currentEditorId).getContent();
	 			}
	 			else {
	 				var val = $(this).find('input[type="text"], input[type="hidden"]').val();
	 				console.log(val);
	 			}
	 			val_section[j] = val;
	 			content[i] = val_section;
	 			j++;
	 		});

	 		i++;
	 	});

    	$.post(path+'administration/request/xhr/content/add_section.php', { 
    		page: page, 
    		lang: lang, 
    		menu_title: menu_title,
    		admin_title: admin_title,
    		show: show, 
    		menu: menu, 
    		menu_id: menu_id, 
    		type: type, 
    		structure: structure, 
    		content: content, 
    		hook: hook,
    		fluid: fluid,
    		add_class: add_class,
    		secure_login: secure_login,
    		secure: secure,
    		token: token
    	}, function(response) {
    		if(response.action=='success') {
    			toastr.success(response.msg);
    		}
    		else {
    			toastr.error(response.msg);
    		}
    	}, 'json');

    	e.preventDefault();
    });

	// save template et contenu
	$(document).on('click', '.delete-section', function(e) {
		$(this).closest('section').remove();
		e.preventDefault();
	});


	// ajouter une nouvelle page
	$(document).on('click', '#add-content', function(e) {
		var lang = $('html').attr('lang');
		var data = $('#add-content-form').serializeArray();
		data[data.length] = { name: 'token', value: token };

		$.getJSON(path+'administration/request/xhr/content/add_content.php', data, function(response) {

			if(response.action=='success') {
				toastr.success(response.msg);
				document.location.href =  path+'administration/index.php?target=content&lang='+lang+'&process=update&Id_contents='+response.id;
			}
			else if(response.action=='empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token') {
				location.reload();
			}            
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
	});

	$('select[name=reload_version]').change(function() {
		var Id_page_content = $(this).val();
		var lang = $('input[name=Lng]').val();
		$('#previewBackup').html('<a href="/'+lang+'?Id_page_content='+Id_page_content+'&preview" target="_blank" class="float-right"><i class="fas fa-desktop url_content"></i></a>');
		$('#Id_page_content').val(Id_page_content);
		$.post(path+'administration/request/xhr/content/reload.php', { 'Id_page_content' : $(this).val(), 'Lng' : $('input[name=Lng]').val() }, function(response) {
			$('#section_target').html(response);
			tinymce.init({
				selector: '.tinymce',
				plugins: "autoresize link lists advlist code help",
				autoresize_bottom_margin: 20,
				branding: false,
				menubar:false,
				statusbar: false,
				toolbar: "undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | link code",
				color_map: [
				"555D65", "Black",
				"E2001A", "Red",
				"89D221", "Green",
				"00254D", "Blue",
				"9ABCE1", "LightBlue"
				]
			});
		});
	});

	$(document).on('change', 'input[name=video]', function(e) {
		var $this = $(this);
		var val = $(this).val();
		$.get(path+'administration/template/section/template/video.php', function(response) {
			$this.closest('[data-type]').find('.preview').html(response.replace('[src]', val));
		});
	});

	$(document).on('change', 'input[name=code]', function(e) {
		var $this = $(this);
		var hook = $(this).val();
		$.get(path+'administration/template/section/template/code.php', {hook: hook}, function(response) {
			$this.closest('[data-type]').find('.preview').html(response);

			tinymce.init({
				selector: '.tinymce',
				plugins: "autoresize link lists advlist code",
				autoresize_bottom_margin: 20,
				branding: false,
				menubar:false,
				statusbar: false,
				toolbar: "formatselect | undo redo | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | removeformat code help"
			});
		});
	});

	// sortable catégories
	if($('body').find('#section_target section').length>0) {
		$('#section_target').sortable({
			axis: 'y',
			start: function (e, ui) {
				$(ui.item).find('textarea').each(function () {
					tinymce.execCommand('mceRemoveEditor', false, $(this).attr('id'));
				});
			},
			stop: function (e, ui) {
				$(ui.item).find('textarea').each(function () {
					tinymce.execCommand('mceAddEditor', true, $(this).attr('id'));
				});
			}
		});
	}

	// sortable catégories
	if($('body').find('.preview [data-hook]').length>0) {
		$('.preview').sortable({
			axis: 'y',
			start: function (e, ui) {
				$(ui.item).find('textarea').each(function () {
					tinymce.execCommand('mceRemoveEditor', false, $(this).attr('id'));
				});
			},
			stop: function (e, ui) {
				$(ui.item).find('textarea').each(function () {
					tinymce.execCommand('mceAddEditor', true, $(this).attr('id'));
				});
			}
		});
	}


	// mettre une page en ligne ou hors ligne
	$(document).on('click', '#sync-page', function(e) {
		var id = $(this).data('id');
		var lang = $(this).data('lang');
		$.getJSON(path+'administration/request/xhr/content/sync-page.php', {id: id, lang: lang, token: token }, function(response) {

			if(response.action=='success') {
				toastr.success(response.msg);
				location.reload();
			}
			else if(response.action=='empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token') {
				location.reload();
			}    
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
	});	

	$(document).on('click', '.add-keyword', function(e) {
		$('#form-save-keyword input[type="text"]').val('');
		$('#form-save-keyword #id_keyword').attr('readonly', false).removeClass('form-control-solid');
		$('#modal-keyword').modal('show'); 
		e.preventDefault();
	});

	$(document).on('keydown keyup change', '.uppercaser', function(e) {
		$(this).val($(this).val().toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\p{Diacritic}/gu, "").replace(/\s+/g, "_").replace(/[^\w\s\']|_/g, "_").replace('___', '_').replace('__', '_').replace(/^_+/, ''));
	});

	$(document).on('click', '.update-keyword', function(e) {
		var id = $(this).data('id');

		$.getJSON(path+'administration/request/xhr/keyword/get-keyword.php', {id:id, token: token }, function(response) {
			if(response.action == 'success') {
				$('#form-save-keyword input[type="text"]').val('');
				$('#form-save-keyword #id_keyword').val(id);

				$('#form-save-keyword #id_keyword').attr('readonly', true).addClass('form-control-solid');

				$.each(response.keywords, function(key, value) {
					$('#form-save-keyword input[name="' + key + '"]:not(#public').val(value);
				});

				if(response.keywords.public == 1) {	
					$('#form-save-keyword #public').prop('checked', true);
				}
				else {
					$('#form-save-keyword #public').prop('checked', false);
				}

				$('#modal-keyword').modal('show'); 
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token') {
				location.reload();
			}
			else {
				toastr.error(response.msg);
			}
		});
		e.preventDefault();
	});


	$(document).on('click', '.add-keys', function(e) {
		$('#form-save-keys input').val('');
		$('#form-save-keys #key-name').attr('readonly', false).removeClass('form-control-solid');
		$('#modal-keys').modal('show'); 
		e.preventDefault();
	});


	$(document).on('click', '.update-keys', function(e) {
		var id = $(this).closest('[data-id]').data('id');

		$.getJSON(path+'administration/request/xhr/settings/get-keys.php', {id:id, token: token }, function(response) {
			if(response.action == 'success') {
				$('#form-save-keys input[type="text"]').val('');
				$('#form-save-keys #id').val(id);

				$('#form-save-keys #key-name').attr('readonly', true).addClass('form-control-solid');
				$('#form-save-keys #key-name').val(response.keys.name);
				$('#form-save-keys #dev').val(response.keys.dev);
				$('#form-save-keys #prod').val(response.keys.prod);
				if(response.keys.public == 1) {					
					$('#form-save-keys #public').prop('checked', true);
				}
				else {
					$('#form-save-keys #public').prop('checked', false);
				}
				

				$('#modal-keys').modal('show'); 
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token') {
				location.reload();
			}
			else {
				toastr.error(response.msg);
			}
		});
		e.preventDefault();
	});

	$(document).on('submit', '#update-meta-form', function(e) {
		var lang = $('html').attr('lang');
		var data = $(this).serializeArray();
		data[data.length] = { name: 'token', value: token };

		$.getJSON(path+'administration/request/xhr/content/meta.php', data, function(response) {

			if(response.action=='success') {
				toastr.success(response.msg);
			}
			else if(response.action=='empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token') {
				location.reload();
			}    
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
	});

	$(document).on('click','.log-show', function(e){
		var id = $(this).data('id');

		$.getJSON(path+'administration/request/xhr/logs/get-logs.php', {id:id, token: token}, function(response){
			if (response.action == 'success') {
				$('#modal_log').modal('show');
				$('#modal_log .modal-title').html(response.title);
				$('#modal_log .modal-body').html(response.html);
			}
		});
	});

	$(document).on('click','.get-logs-errors', function(e){
		e.preventDefault();

		var id = $(this).closest('[data-id]').data('id');

		$.getJSON(path+'administration/request/xhr/settings/get-logs-errors.php', {id:id, token: token}, function(response){
			if (response.action == 'success') {
				$('#modal-logs-errors').modal('show');
				$('#modal-logs-errors .modal-title').html(response.title);
				$('#modal-logs-errors .modal-body').html(response.html);
			}
		});
	});

	$(document).on('click', '.get-file', function(e){
		e.preventDefault();
		var id = $(this).data('id');

		$.getJSON(path+'administration/request/xhr/files/get-file.php', {id:id, token: token}, function(response){
			if (response.action == 'success') {
				$('#modal-update-file').modal('show');
				$('#modal-update-file .modal-title span').html(response.file.filename);

				var form = '#modal-update-file #form-update-file';
				$(form).find('input').val('');

				$.each(response.file, function(i, item) {
					if($(form).find('#'+i).prop('tagName') == 'INPUT') {
				    	$(form).find('#'+i).val(item);
				    }
				    else {
						$(form).find('#'+i).text(item);
				    }
				});
				// $('#modal-update-file #form-update-file #filename').val(response.file.name);
				// $('#modal-update-file #form-update-file #link').val(response.file.link);
				// $('#modal-update-file #form-update-file #size').html(response.file.size);
				// $('#modal-update-file #form-update-file #updated-at').html(response.file.updated_at);
				// $('#modal-update-file #form-update-file #id').html(response.file.id);

				$('#modal-update-file #alt').addClass('d-none');
				$('#modal-update-file #dimension').addClass('d-none');

				if(response.file.type == 'image') {
					$('#modal-update-file #alt').removeClass('d-none');
					$('#modal-update-file #dimension').removeClass('d-none');
					$('#modal-update-file #preview').html('<img src="/dist/assets/img/'+response.file.path+response.file.filename+'" class="mh-100 mw-100">');
				}
				else if(response.file.type == 'video') {
					$('#modal-update-file #preview').html('<i class="fa-duotone fa-clapperboard-play fa-2xl text-primary"></i>');
				}
				else {
					$('#modal-update-file #preview').html('<i class="fa-duotone fa-file fa-2xl text-primary"></i>');
				}
			}
		});
	});

	$(document).on('click','[data-settings-users]', function(e){
		var id = $(this).closest('[data-id]').data('id');
		var type = $(this).data('settings-users');

		var access;
		if($(this).is(':checked')) {
			access = 1;
		}
		else {
			access = 0;
		}

		$.post(path+'administration/request/xhr/settings/update-access.php', {id:id, access: access, type: type, token: token}, function(response){
			if(response.action=='success') {
				toastr.success(response.msg);
			}
			else if(response.action=='empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token') {
				location.reload();
			}    
			else {
				toastr.error(response.msg);
			}
		}, 'json');
	});

	$(document).on('click','[data-settings-modules]', function(e){
		var id = $(this).closest('[data-id]').data('id');

		var access;
		if($(this).is(':checked')) {
			access = 1;
		}
		else {
			access = 0;
		}

		$.post(path+'administration/request/xhr/settings/update-module.php', {id:id, access: access, token: token}, function(response){
			if(response.action=='success') {
				toastr.success(response.msg);
			}
			else if(response.action=='empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token') {
				location.reload();
			}    
			else {
				toastr.error(response.msg);
			}
		}, 'json');
	});

	$(document).on('change','#lng-default', function(e){
		var id = $(this).val();

		$.post(path+'administration/request/xhr/settings/update-default-language.php', {id:id, token: token}, function(response){
			if(response.action=='success') {
				toastr.success(response.msg);
			}
			else if(response.action=='empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token') {
				location.reload();
			}    
			else {
				toastr.error(response.msg);
			}
		}, 'json');
	});

	$(document).on('click','[data-settings-languages]', function(e){
		var id = $(this).closest('[data-id]').data('id');

		var access;
		if($(this).is(':checked')) {
			access = 1;
		}
		else {
			access = 0;
		}

		$.post(path+'administration/request/xhr/settings/update-language.php', {id:id, access: access, token: token}, function(response){
			if(response.action=='success') {
				toastr.success(response.msg);
			}
			else if(response.action=='empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token') {
				location.reload();
			}    
			else {
				toastr.error(response.msg);
			}
		}, 'json');
	});

	$(document).on('click','.define a', function(e){
		e.preventDefault();
		var text = $(this).closest('td').find('span').text();
		
		if (location.protocol === 'https:') {
			navigator.clipboard.writeText(text).then(() => {	        
				toastr.success(text+' copied !');
		    });
		}
		else {
			toastr.error('Copy function doesn\'t work on non https protocol !');
		}
	});


	$(document).on('click','[data-copy]', function(e){
		e.preventDefault();
		var id = $(this).data('copy');

		if($('[data-copy-target='+id+']').prop('tagName') == 'INPUT') {
			var text = $('[data-copy-target='+id+']').val();
		}
		else {
			var text = $('[data-copy-target='+id+']').text();
		}
		
		
		if (location.protocol === 'https:') {
			navigator.clipboard.writeText(text).then(() => {	        
				toastr.success(text+' copied !');
		    });
		}
		else {
			toastr.error('Copy function doesn\'t work on non https protocol !');
		}
	});
	
	$(document).on('click','[data-mode]', function(e){
		e.preventDefault();
		var mode = $(this).data('mode');

		$('#preview').removeClass('light dark');
		$('#preview').addClass(mode);

		$('[data-mode]').removeClass('d-none');
		$('[data-mode='+mode+']').addClass('d-none');
	});

	// Format options
	var optionFormat = function(item) {
	    if ( !item.id ) {
	        return item.text;
	    }

	    var span = document.createElement('span');
	    var imgUrl = item.element.getAttribute('data-select2-from');
	    var template = '';

	    template += imgUrl;
	    template += item.text;

	    span.innerHTML = template;

	    return $(span);
	}

	// Init Select2 --- more info: https://select2.org/
	$('#modal-ticket #from').select2({
	    templateSelection: optionFormat,
	    templateResult: optionFormat
	});


	// Format options
	var optionFormat = function(item) {
	    if ( !item.id ) {
	        return item.text;
	    }

	    var span = document.createElement('span');
	    var imgUrl = item.element.getAttribute('data-select2-assign-to');
	    var template = '';

	    template += imgUrl;
	    template += item.text;

	    span.innerHTML = template;

	    return $(span);
	}

	// Init Select2 --- more info: https://select2.org/
	$('#assign-to').select2({
	    templateSelection: optionFormat,
	    templateResult: optionFormat
	});

	$('#modal-ticket').on('hidden.bs.modal', function (e) {
		$('#modal-ticket .ticket-nbr').html('');
		$('#modal-ticket').find('input, select, textarea').val('');
		$('#modal-ticket input[type=checkbox]').prop('checked', false);
		$('#modal-ticket #ticket-status').val('10');
		$('#modal-ticket [data-control="select2"]').trigger('change.select2'); 
	});

	"use strict";

	// Class definition
	if($('.data-table').length > 0) {
		var KTDatatablesButtons = function () {
		    // Shared variables
		    var table;
		    var datatable;

		    // Private functions
		    var initDatatable = function () {
		        // Set date data order
		        const tableRows = table.querySelectorAll('tbody tr');

		        tableRows.forEach(row => {
		            const dateRow = row.querySelectorAll('td');
		        });

		        // Init datatable --- more info on datatables: https://datatables.net/manual/
		        if($('[data-table-order]').length > 0) {
			        datatable = $(table).DataTable({
			            "info": false,
			            'pageLength': 50,
			            rowReorder: true,
			        });

			        datatable.on( 'row-reorder', function ( e, diff, edit ) {

				        var order_arr = new Array;
				        var order_db = $('[data-table-order]').data('table-order');

				        $('[data-table-order] tbody tr').each(function() {
				        	order_arr.push($(this).data('id'));
				        });

				        $.post('../administration/request/xhr/'+order_db+'/order.php', {order_arr: order_arr, token: token}, function(response) {
				        	// location.reload();
				        }, 'json');
				    });
			    }
			    else {
			    	datatable = $(table).DataTable({
			            "info": false,
			            'order': [],
			            'pageLength': 50,
			            ordering: true,
			           "aaSorting": []
			        });
			    }
		    }

		    // Hook export buttons
		    var exportButtons = () => {
		        const documentTitle = 'Customer Orders Report';
		        var buttons = new $.fn.dataTable.Buttons(table, {
		            buttons: [
		                {
		                    extend: 'copyHtml5',
		                    title: documentTitle
		                },
		                {
		                    extend: 'excelHtml5',
		                    title: documentTitle
		                },
		                {
		                    extend: 'csvHtml5',
		                    title: documentTitle
		                },
		                {
		                    extend: 'pdfHtml5',
		                    title: documentTitle
		                }
		            ]
		        }).container().appendTo($('#datatable-export'));

		        // Hook dropdown menu click event to datatable export buttons
		        const exportButtons = document.querySelectorAll('#datatable-export-menu [data-kt-export]');
		        exportButtons.forEach(exportButton => {
		            exportButton.addEventListener('click', e => {
		                e.preventDefault();

		                // Get clicked export value
		                const exportValue = e.target.getAttribute('data-kt-export');
		                const target = document.querySelector('.dt-buttons .buttons-' + exportValue);

		                // Trigger click event on hidden datatable export buttons
		                target.click();
		            });
		        });
		    }

		    // Search Datatable --- official docs reference: https://datatables.net/reference/api/search()
		     var handleSearchDatatable = () => {
		        const filterSearch = document.querySelector('[data-kt-filter]');
		        const preFilterSearch = $('[data-kt-filter]').data('kt-filter');
		        if(preFilterSearch != '') {
		        	datatable.search(preFilterSearch).draw();
		        	$('[data-kt-filter]').val(preFilterSearch);
		        }

		        filterSearch.addEventListener('keyup', function (e) {
		            datatable.search(e.target.value).draw();
		        });
		    }

		    // Public methods
		    return {
		        init: function () {
		            table = document.querySelector('.data-table');

		            if ( !table ) {
		                return;
		            }

		            initDatatable();
		            exportButtons();
		            handleSearchDatatable();
		        }
		    };
		}();

		// On document ready
		KTUtil.onDOMContentLoaded(function () {
		    KTDatatablesButtons.init();
		});
	}







	/*if($('#kt_dropzonejs_image').length > 0) {
		// set the dropzone container id
		const id = "#kt_dropzonejs_image";
		const dropzone = document.querySelector(id);

		// set the preview element template
		var previewNode = dropzone.querySelector(".dropzone-item");
		previewNode.id = "";
		var previewTemplate = previewNode.parentNode.innerHTML;
		previewNode.parentNode.removeChild(previewNode);


		var folder = $("#kt_dropzonejs_image").data('folder');
		var record = $("#kt_dropzonejs_image").data('record');
		var input = $("#kt_dropzonejs_image").data('input');


		var myDropzone = new Dropzone(id, { // Make the whole body a dropzone
		    url: path+'administration/request/xhr/upload/upload.php?folder='+folder+'&record='+record+'&input='+input, // Set the url for your upload script location
		    acceptedFiles: 'image/*',
		    parallelUploads: 20,
		    maxFilesize: 8, // Max filesize in MB
		    previewTemplate: previewTemplate,
		    previewsContainer: id + " .dropzone-items", // Define the container to display the previews
		    clickable: id + " .dropzone-select" // Define the element that should be used as click trigger to select files.
		});

		myDropzone.on("addedfile", function (file) {
		    // Hookup the start button
		    const dropzoneItems = dropzone.querySelectorAll('.dropzone-item');
		    dropzoneItems.forEach(dropzoneItem => {
		        dropzoneItem.style.display = '';
		    });
		});

		// Update the total progress bar
		myDropzone.on("totaluploadprogress", function (progress) {
		    const progressBars = dropzone.querySelectorAll('.progress-bar');
		    progressBars.forEach(progressBar => {
		        progressBar.style.width = progress + "%";
		    });
		});

		myDropzone.on("sending", function (file) {
		    // Show the total progress bar when upload starts
		    const progressBars = dropzone.querySelectorAll('.progress-bar');
		    progressBars.forEach(progressBar => {
		        progressBar.style.opacity = "1";
		    });
		});

		// Hide the total progress bar when nothing"s uploading anymore
		myDropzone.on("complete", function (progress) {
		    const progressBars = dropzone.querySelectorAll('.dz-complete');

		    setTimeout(function () {
		        progressBars.forEach(progressBar => {
		            progressBar.querySelector('.progress-bar').style.opacity = "0";
		            progressBar.querySelector('.progress').style.opacity = "0";
		        });
		    }, 300);
		    console.log(progress);

		    if(progress.status == 'success') {    	
			    toastr.success('File uploaded')
			    setTimeout(function () {
			        location.reload();
			    }, 3000);
		    }
		    
		});
	}*/

function filemanager_dropzone(path, source) {
	var folder = $("#kt_dropzonejs_image").data('folder');
	var record = $("#kt_dropzonejs_image").data('record');
	var input = $("#kt_dropzonejs_image").data('input');
	console.log(source);

	var myDropzone = new Dropzone("#kt_dropzonejs_image", {
	    url: path+'administration/request/xhr/upload/upload.php?folder='+folder+'&record='+record+'&input='+input, // Set the url for your upload script location
	    paramName: "file", // The name that will be used to transfer the file
	    maxFiles: 10,
	    maxFilesize: 200, // MB
	    addRemoveLinks: true,
	    success: function(file, response) {
			response = JSON.parse(response);
			
      		if($('#no-file-result').length > 0) {
      			$('#no-file-result').remove();
      		}

      		if(response.path === null) {
      			response.path = '';
      		}

      		var file = response.filename+'.'+response.ext;
      		var folder_url = encodeURI(response.path)+response.filename+'.'+response.ext;
      		var folder = response.path+response.filename+'.'+response.ext;

      		if(source == 'file-manager') {
      			var src = 'get-file';
      			var data_xhr = 'files/get-file';
      		}
      		else if(source == 'content-manager') {
      			var src = 'select-image';
      			var data_xhr = 'content/select-image';
      		}

      		var template = `<a href="" class="w-150px h-150px card shadow-sm overflow-hidden mt-5 me-5 ${src}" data-xhr="${data_xhr}" data-id="${folder}">
								    <div class="card-body flex-column align-items-center p-0 file-box">`;

	      	if(response.type == 'img') {

	      		var template = template + `<img src="/dist/assets/img/${folder}" class="img-fluid">`

	      	}
	      	else if(response.type == 'video') {
	      		var template = template + `<i class="fa-duotone fa-clapperboard-play fa-2xl text-primary"></i><span class="mt-3 text-center">${file}</span>`;
	      	}
	      	else {
	      		var template = template + `<i class="fa-duotone fa-file fa-2xl text-primary"></i><span class="mt-3 text-center">${file}</span>`;
	      	}

	      	template += `	</div>
						</a>`;


			$(template).prependTo('#file-result');
		}
	});
}

if($('#kt_dropzonejs_image').length > 0) {
	filemanager_dropzone(path, 'file-manager')
}




	// Class definition
	var KTFileManagerList = function () {
	    // Define shared variables
	    var datatable;
	    var table

	    // Define template element variables
	    var uploadTemplate;
	    var renameTemplate;
	    var actionTemplate;
	    var checkboxTemplate;


	    // Private functions
	    const initTemplates = () => {
	        uploadTemplate = document.querySelector('[data-kt-filemanager-template="upload"]');
	        renameTemplate = document.querySelector('[data-kt-filemanager-template="rename"]');
	        actionTemplate = document.querySelector('[data-kt-filemanager-template="action"]');
	        checkboxTemplate = document.querySelector('[data-kt-filemanager-template="checkbox"]');
	    }

	    const initDatatable = () => {
	        // Set date data order
	        const tableRows = table.querySelectorAll('tbody tr');

	        tableRows.forEach(row => {
	            const dateRow = row.querySelectorAll('td');
	            const dateCol = dateRow[3]; // select date from 4th column in table
	            const realDate = moment(dateCol.innerHTML, "DD MMM YYYY, LT").format();
	            // dateCol.setAttribute('data-order', realDate);
	        });

	        const foldersListOptions = {
	            "info": false,
	            'order': [],
	            // "scrollY": "700px",
	            // "scrollCollapse": true,
	            "paging": false,
	            'ordering': false,
	            'columns': [
	                { data: 'checkbox' },
	                { data: 'name' },
	                { data: 'size' },
	                { data: 'date' },
	                { data: 'action' },
	            ],
	            'language': {
	                emptyTable: `<div class="d-flex flex-column flex-center">
	                    <img src="${hostUrl}media/illustrations/sketchy-1/5.png" class="mw-400px" />
	                    <div class="fs-1 fw-bolder text-dark">No items found.</div>
	                    <div class="fs-6">Start creating new folders or uploading a new file!</div>
	                </div>`
	            }
	        };

	        const filesListOptions = {
	            "info": false,
	            'order': [],
	            'pageLength': 10,
	            "lengthChange": false,
	            'ordering': false,
	            'columns': [
	                { data: 'checkbox' },
	                { data: 'name' },
	                { data: 'size' },
	                { data: 'date' },
	                { data: 'action' },
	            ],
	            'language': {
	                emptyTable: `<div class="d-flex flex-column flex-center">
	                    <img src="${hostUrl}media/illustrations/sketchy-1/5.png" class="mw-400px" />
	                    <div class="fs-1 fw-bolder text-dark mb-4">No items found.</div>
	                    <div class="fs-6">Start creating new folders or uploading a new file!</div>
	                </div>`
	            },
	            conditionalPaging: true
	        };

	        // Define datatable options to load
	        var loadOptions;
	        if (table.getAttribute('data-kt-filemanager-table') === 'folders') {
	            loadOptions = foldersListOptions;
	        } else {
	            loadOptions = filesListOptions;
	        }

	        // Init datatable --- more info on datatables: https://datatables.net/manual/
	        datatable = $(table).DataTable(loadOptions);

	        // Re-init functions on every table re-draw -- more info: https://datatables.net/reference/event/draw
	        datatable.on('draw', function () {
	            initToggleToolbar();
	            // handleDeleteRows();
	            toggleToolbars();
	            resetNewFolder();
	            KTMenu.createInstances();
	            // initCopyLink();
	            countTotalItems();
	            handleRename();
	        });
	    }

	    // Search Datatable --- official docs reference: https://datatables.net/reference/api/search()
	    const handleSearchDatatable = () => {
	        const filterSearch = document.querySelector('[data-kt-filemanager-table-filter="search"]');
	        filterSearch.addEventListener('keyup', function (e) {
	            datatable.search(e.target.value).draw();
	        });
	    }

	    // Delete customer
	    /*const handleDeleteRows = () => {
	        // Select all delete buttons
	        const deleteButtons = table.querySelectorAll('[data-kt-filemanager-table-filter="delete_row"]');

	        deleteButtons.forEach(d => {
	            // Delete button on click
	            d.addEventListener('click', function (e) {
	                e.preventDefault();

	                // Select parent row
	                const parent = e.target.closest('tr');

	                // Get customer name
	                const fileName = parent.querySelectorAll('td')[1].innerText;

	                // SweetAlert2 pop up --- official docs reference: https://sweetalert2.github.io/
	                Swal.fire({
	                    text: "Are you sure you want to delete " + fileName + "?",
	                    icon: "warning",
	                    showCancelButton: true,
	                    buttonsStyling: false,
	                    confirmButtonText: "Yes, delete!",
	                    cancelButtonText: "No, cancel",
	                    customClass: {
	                        confirmButton: "btn fw-bold btn-danger",
	                        cancelButton: "btn fw-bold btn-active-light-primary"
	                    }
	                }).then(function (result) {
	                    if (result.value) {
	                        Swal.fire({
	                            text: "You have deleted " + fileName + "!.",
	                            icon: "success",
	                            buttonsStyling: false,
	                            confirmButtonText: "Ok, got it!",
	                            customClass: {
	                                confirmButton: "btn fw-bold btn-primary",
	                            }
	                        }).then(function () {
	                            // Remove current row
	                            datatable.row($(parent)).remove().draw();
	                        });
	                    } else if (result.dismiss === 'cancel') {
	                        Swal.fire({
	                            text: customerName + " was not deleted.",
	                            icon: "error",
	                            buttonsStyling: false,
	                            confirmButtonText: "Ok, got it!",
	                            customClass: {
	                                confirmButton: "btn fw-bold btn-primary",
	                            }
	                        });
	                    }
	                });
	            })
	        });
	    }*/

	    // Init toggle toolbar
	    const initToggleToolbar = () => {
	        // Toggle selected action toolbar
	        // Select all checkboxes
	        var checkboxes = table.querySelectorAll('[type="checkbox"]');
	        if (table.getAttribute('data-kt-filemanager-table') === 'folders') {
	            checkboxes = document.querySelectorAll('#kt_file_manager_list_wrapper [type="checkbox"]');
	        }

	        // Select elements
	        const deleteSelected = document.querySelector('[data-kt-filemanager-table-select="delete_selected"]');

	        // Toggle delete selected toolbar
	        checkboxes.forEach(c => {
	            // Checkbox on click event
	            c.addEventListener('click', function () {
	                console.log(c);
	                setTimeout(function () {
	                    toggleToolbars();
	                }, 50);
	            });
	        });

	        // Deleted selected rows
	        deleteSelected.addEventListener('click', function () {
	            // SweetAlert2 pop up --- official docs reference: https://sweetalert2.github.io/
	            Swal.fire({
	                text: "Are you sure you want to delete selected files or folders?",
	                icon: "warning",
	                showCancelButton: true,
	                buttonsStyling: false,
	                confirmButtonText: "Yes, delete!",
	                cancelButtonText: "No, cancel",
	                customClass: {
	                    confirmButton: "btn fw-bold btn-danger",
	                    cancelButton: "btn fw-bold btn-active-light-primary"
	                }
	            }).then(function (result) {
	                if (result.value) {
	                    Swal.fire({
	                        text: "You have deleted all selected  files or folders!.",
	                        icon: "success",
	                        buttonsStyling: false,
	                        confirmButtonText: "Ok, got it!",
	                        customClass: {
	                            confirmButton: "btn fw-bold btn-primary",
	                        }
	                    }).then(function () {
	                        // Remove all selected customers
	                        checkboxes.forEach(c => {
	                            if (c.checked) {
	                                datatable.row($(c.closest('tbody tr'))).remove().draw();
	                            }
	                        });

	                        // Remove header checked box
	                        const headerCheckbox = table.querySelectorAll('[type="checkbox"]')[0];
	                        headerCheckbox.checked = false;
	                    });
	                } else if (result.dismiss === 'cancel') {
	                    Swal.fire({
	                        text: "Selected  files or folders was not deleted.",
	                        icon: "error",
	                        buttonsStyling: false,
	                        confirmButtonText: "Ok, got it!",
	                        customClass: {
	                            confirmButton: "btn fw-bold btn-primary",
	                        }
	                    });
	                }
	            });
	        });
	    }

	    // Toggle toolbars
	    const toggleToolbars = () => {
	        // Define variables
	        const toolbarBase = document.querySelector('[data-kt-filemanager-table-toolbar="base"]');
	        const toolbarSelected = document.querySelector('[data-kt-filemanager-table-toolbar="selected"]');
	        const selectedCount = document.querySelector('[data-kt-filemanager-table-select="selected_count"]');

	        // Select refreshed checkbox DOM elements 
	        const allCheckboxes = table.querySelectorAll('tbody [type="checkbox"]');

	        // Detect checkboxes state & count
	        let checkedState = false;
	        let count = 0;

	        // Count checked boxes
	        allCheckboxes.forEach(c => {
	            if (c.checked) {
	                checkedState = true;
	                count++;
	            }
	        });

	        // Toggle toolbars
	        if (checkedState) {
	            selectedCount.innerHTML = count;
	            toolbarBase.classList.add('d-none');
	            toolbarSelected.classList.remove('d-none');
	        } else {
	            toolbarBase.classList.remove('d-none');
	            toolbarSelected.classList.add('d-none');
	        }
	    }

	    // Handle new folder
	    const handleNewFolder = () => {
	        // Select button
	        const newFolder = document.getElementById('kt_file_manager_new_folder');

	        // Handle click action
	        newFolder.addEventListener('click', e => {
	            e.preventDefault();

	            // Ignore if input already exist
	            if (table.querySelector('#kt_file_manager_new_folder_row')) {
	                return;
	            }

	            // Add new blank row to datatable
	            const tableBody = table.querySelector('tbody');
	            const rowElement = uploadTemplate.cloneNode(true); // Clone template markup
	            tableBody.prepend(rowElement);

	            // Define template interactive elements
	            const rowForm = rowElement.querySelector('#kt_file_manager_add_folder_form');
	            const rowButton = rowElement.querySelector('#kt_file_manager_add_folder');
	            const cancelButton = rowElement.querySelector('#kt_file_manager_cancel_folder');
	            const folderIcon = rowElement.querySelector('.svg-icon-2x');
	            const rowInput = rowElement.querySelector('[name="new_folder_name"]');

	            // Define validator
	            // Init form validation rules. For more info check the FormValidation plugin's official documentation:https://formvalidation.io/
	            var validator = FormValidation.formValidation(
	                rowForm,
	                {
	                    fields: {
	                        'new_folder_name': {
	                            validators: {
	                                notEmpty: {
	                                    message: 'Folder name is required'
	                                }
	                            }
	                        },
	                    },
	                    plugins: {
	                        trigger: new FormValidation.plugins.Trigger(),
	                        bootstrap: new FormValidation.plugins.Bootstrap5({
	                            rowSelector: '.fv-row',
	                            eleInvalidClass: '',
	                            eleValidClass: ''
	                        })
	                    }
	                }
	            );

	            // Handle add new folder button
	            rowButton.addEventListener('click', e => {
	                e.preventDefault();

	                // Activate indicator
	                rowButton.setAttribute("data-kt-indicator", "on");

	                // Validate form before submit
	                if (validator) {
	                    validator.validate().then(function (status) {
	                        //console.log('validated!');


	                        if (status == 'Valid') {
	                            // Simulate process for demo only
	                            setTimeout(function () {
	                                // Create folder link
	                                const folderLink = document.createElement('a');
	                                const folderLinkClasses = ['text-gray-800', 'text-hover-primary'];
	                                folderLink.setAttribute('href', '?page=apps/file-manager/blank');
	                                folderLink.classList.add(...folderLinkClasses);
	                                folderLink.innerText = rowInput.value;

	                                const newRow = datatable.row.add({
	                                    'checkbox': checkboxTemplate.innerHTML,
	                                    'name': folderIcon.outerHTML + folderLink.outerHTML,
	                                    "size": '-',
	                                    "date": '-',
	                                    'action': actionTemplate.innerHTML
	                                }).node();
	                                $(newRow).find('td').eq(4).attr('data-kt-filemanager-table', 'action_dropdown');
	                                $(newRow).find('td').eq(4).addClass('text-end'); // Add custom class to last 'td' element --- more info: https://datatables.net/forums/discussion/22341/row-add-cell-class

	                                // Re-sort datatable to allow new folder added at the top
	                                var index = datatable.row(0).index(),
	                                    rowCount = datatable.data().length - 1,
	                                    insertedRow = datatable.row(rowCount).data(),
	                                    tempRow;

	                                for (var i = rowCount; i > index; i--) {
	                                    tempRow = datatable.row(i - 1).data();
	                                    datatable.row(i).data(tempRow);
	                                    datatable.row(i - 1).data(insertedRow);
	                                }


									// xhr_send('media/add-folder', token, $('#kt_file_manager_add_folder'));

	                                // toastr.success(rowInput.value + ' was created!');

	                                // Disable indicator
	                                rowButton.removeAttribute("data-kt-indicator");

	                                // Reset input
	                                rowInput.value = '';

	                                datatable.draw(false);

	                                setTimeout(function () {
	                            		location.reload();
	                            	}, 1500);

	                            }, 1000);
	                        } else {
	                            // Disable indicator
	                            rowButton.removeAttribute("data-kt-indicator");
	                        }
	                    });
	                }
	            });

	            // Handle cancel new folder button
	            cancelButton.addEventListener('click', e => {
	                e.preventDefault();

	                // Activate indicator
	                cancelButton.setAttribute("data-kt-indicator", "on");

	                setTimeout(function () {
	                    // Disable indicator
	                    cancelButton.removeAttribute("data-kt-indicator");

	                    // Toggle toastr
	                    toastr.options = {
	                        "closeButton": true,
	                        "debug": false,
	                        "newestOnTop": false,
	                        "progressBar": false,
	                        "positionClass": "toastr-top-right",
	                        "preventDuplicates": false,
	                        "showDuration": "300",
	                        "hideDuration": "1000",
	                        "timeOut": "5000",
	                        "extendedTimeOut": "1000",
	                        "showEasing": "swing",
	                        "hideEasing": "linear",
	                        "showMethod": "fadeIn",
	                        "hideMethod": "fadeOut"
	                    };

	                    toastr.error('Cancelled new folder creation');
	                    resetNewFolder();
	                }, 1000);
	            });
	        });
	    }

	    // Reset add new folder input
	    const resetNewFolder = () => {
	        const newFolderRow = table.querySelector('#kt_file_manager_new_folder_row');

	        if (newFolderRow) {
	            newFolderRow.parentNode.removeChild(newFolderRow);
	        }
	    }

	    // Handle rename file or folder
	    const handleRename = () => {
	        const renameButton = table.querySelectorAll('[data-kt-filemanager-table="rename"]');     

	        renameButton.forEach(button => {
	            button.addEventListener('click', renameCallback);
	        });
	    }

	    // Rename callback
	    const renameCallback = (e) => {
	        e.preventDefault();

	        // Define shared value
	        let nameValue;

	        // Stop renaming if there's an input existing
	        if (table.querySelectorAll('#kt_file_manager_rename_input').length > 0) {
	            Swal.fire({
	                text: "Unsaved input detected. Please save or cancel the current item",
	                icon: "warning",
	                buttonsStyling: false,
	                confirmButtonText: "Ok, got it!",
	                customClass: {
	                    confirmButton: "btn fw-bold btn-danger"
	                }
	            });

	            return;
	        }

	        // Select parent row
	        const parent = e.target.closest('tr');

	        // Get name column
	        const nameCol = parent.querySelectorAll('td')[1];
	        const colIcon = nameCol.querySelector('.svg-icon');
	        nameValue = nameCol.innerText;

	        // Set rename input template
	        const renameInput = renameTemplate.cloneNode(true);
	        renameInput.querySelector('#kt_file_manager_rename_folder_icon').innerHTML = colIcon.outerHTML;

	        // Swap current column content with input template
	        nameCol.innerHTML = renameInput.innerHTML;

	        // Set input value with current file/folder name
	        parent.querySelector('#kt_file_manager_rename_input').value = nameValue;

	        // Rename file / folder validator
	        var renameValidator = FormValidation.formValidation(
	            nameCol,
	            {
	                fields: {
	                    'rename_folder_name': {
	                        validators: {
	                            notEmpty: {
	                                message: 'Name is required'
	                            }
	                        }
	                    },
	                },
	                plugins: {
	                    trigger: new FormValidation.plugins.Trigger(),
	                    bootstrap: new FormValidation.plugins.Bootstrap5({
	                        rowSelector: '.fv-row',
	                        eleInvalidClass: '',
	                        eleValidClass: ''
	                    })
	                }
	            }
	        );

	        // Rename input button action
	        const renameInputButton = document.querySelector('#kt_file_manager_rename_folder');
	        renameInputButton.addEventListener('click', e => {
	            e.preventDefault();

	            // Detect if valid
	            if (renameValidator) {
	                renameValidator.validate().then(function (status) {
	                    console.log('validated!');

	                    if (status == 'Valid') {
	                        // Pop up confirmation
	                        Swal.fire({
	                            text: "Are you sure you want to rename " + nameValue + "?",
	                            icon: "warning",
	                            showCancelButton: true,
	                            buttonsStyling: false,
	                            confirmButtonText: "Yes, rename it!",
	                            cancelButtonText: "No, cancel",
	                            customClass: {
	                                confirmButton: "btn fw-bold btn-danger",
	                                cancelButton: "btn fw-bold btn-active-light-primary"
	                            }
	                        }).then(function (result) {
	                            if (result.value) {
	                                Swal.fire({
	                                    text: "You have renamed " + nameValue + "!.",
	                                    icon: "success",
	                                    buttonsStyling: false,
	                                    confirmButtonText: "Ok, got it!",
	                                    customClass: {
	                                        confirmButton: "btn fw-bold btn-primary",
	                                    }
	                                }).then(function () {
	                                    // Get new file / folder name value
	                                    const newValue = document.querySelector('#kt_file_manager_rename_input').value;

	                                    // New column data template
	                                    const newData = `<div class="d-flex align-items-center">
	                                        ${colIcon.outerHTML}
	                                        <a href="?page=apps/file-manager/files/" class="text-gray-800 text-hover-primary">${newValue}</a>
	                                    </div>`;

	                                    // Draw datatable with new content -- Add more events here for any server-side events
	                                    datatable.cell($(nameCol)).data(newData).draw();
	                                });
	                            } else if (result.dismiss === 'cancel') {
	                                Swal.fire({
	                                    text: nameValue + " was not renamed.",
	                                    icon: "error",
	                                    buttonsStyling: false,
	                                    confirmButtonText: "Ok, got it!",
	                                    customClass: {
	                                        confirmButton: "btn fw-bold btn-primary",
	                                    }
	                                });
	                            }
	                        });
	                    }
	                });
	            }
	        });

	        // Cancel rename input
	        const cancelInputButton = document.querySelector('#kt_file_manager_rename_folder_cancel');
	        cancelInputButton.addEventListener('click', e => {
	            e.preventDefault();

	            // Simulate process for demo only
	            cancelInputButton.setAttribute("data-kt-indicator", "on");

	            setTimeout(function () {
	                const revertTemplate = `<div class="d-flex align-items-center">
	                    ${colIcon.outerHTML}
	                    <a href="?page=apps/file-manager/files/" class="text-gray-800 text-hover-primary">${nameValue}</a>
	                </div>`;

	                // Remove spinner
	                cancelInputButton.removeAttribute("data-kt-indicator");

	                // Draw datatable with new content -- Add more events here for any server-side events
	                datatable.cell($(nameCol)).data(revertTemplate).draw();

	                // Toggle toastr
	                toastr.options = {
	                    "closeButton": true,
	                    "debug": false,
	                    "newestOnTop": false,
	                    "progressBar": false,
	                    "positionClass": "toastr-top-right",
	                    "preventDuplicates": false,
	                    "showDuration": "300",
	                    "hideDuration": "1000",
	                    "timeOut": "5000",
	                    "extendedTimeOut": "1000",
	                    "showEasing": "swing",
	                    "hideEasing": "linear",
	                    "showMethod": "fadeIn",
	                    "hideMethod": "fadeOut"
	                };

	                toastr.error('Cancelled rename function');
	            }, 1000);
	        });
	    }

	    // Init dropzone
	    const initDropzone = () => {
	        // set the dropzone container id
	        const id = "#kt_modal_upload_dropzone";
	        const dropzone = document.querySelector(id);

	        // set the preview element template
	        var previewNode = dropzone.querySelector(".dropzone-item");
	        previewNode.id = "";
	        var previewTemplate = previewNode.parentNode.innerHTML;
	        previewNode.parentNode.removeChild(previewNode);

	        var myDropzone = new Dropzone(id, { // Make the whole body a dropzone
	            url: "path/to/your/server", // Set the url for your upload script location
	            parallelUploads: 10,
	            previewTemplate: previewTemplate,
	            maxFilesize: 1, // Max filesize in MB
	            autoProcessQueue: false, // Stop auto upload
	            autoQueue: false, // Make sure the files aren't queued until manually added
	            previewsContainer: id + " .dropzone-items", // Define the container to display the previews
	            clickable: id + " .dropzone-select" // Define the element that should be used as click trigger to select files.
	        });

	        myDropzone.on("addedfile", function (file) {
	            // Hook each start button
	            file.previewElement.querySelector(id + " .dropzone-start").onclick = function () {
	                // myDropzone.enqueueFile(file); -- default dropzone function

	                // Process simulation for demo only
	                const progressBar = file.previewElement.querySelector('.progress-bar');
	                progressBar.style.opacity = "1";
	                var width = 1;
	                var timer = setInterval(function () {
	                    if (width >= 100) {
	                        myDropzone.emit("success", file);
	                        myDropzone.emit("complete", file);
	                        clearInterval(timer);
	                    } else {
	                        width++;
	                        progressBar.style.width = width + '%';
	                    }
	                }, 20);
	            };

	            const dropzoneItems = dropzone.querySelectorAll('.dropzone-item');
	            dropzoneItems.forEach(dropzoneItem => {
	                dropzoneItem.style.display = '';
	            });
	            dropzone.querySelector('.dropzone-upload').style.display = "inline-block";
	            dropzone.querySelector('.dropzone-remove-all').style.display = "inline-block";
	        });

	        // Hide the total progress bar when nothing's uploading anymore
	        myDropzone.on("complete", function (file) {
	            const progressBars = dropzone.querySelectorAll('.dz-complete');
	            setTimeout(function () {
	                progressBars.forEach(progressBar => {
	                    progressBar.querySelector('.progress-bar').style.opacity = "0";
	                    progressBar.querySelector('.progress').style.opacity = "0";
	                    progressBar.querySelector('.dropzone-start').style.opacity = "0";
	                });
	            }, 300);
	        });

	        // Setup the buttons for all transfers
	        dropzone.querySelector(".dropzone-upload").addEventListener('click', function () {
	            // myDropzone.processQueue(); --- default dropzone process

	            // Process simulation for demo only
	            myDropzone.files.forEach(file => {
	                const progressBar = file.previewElement.querySelector('.progress-bar');
	                progressBar.style.opacity = "1";
	                var width = 1;
	                var timer = setInterval(function () {
	                    if (width >= 100) {
	                        myDropzone.emit("success", file);
	                        myDropzone.emit("complete", file);
	                        clearInterval(timer);
	                    } else {
	                        width++;
	                        progressBar.style.width = width + '%';
	                    }
	                }, 20);
	            });
	        });

	        // Setup the button for remove all files
	        dropzone.querySelector(".dropzone-remove-all").addEventListener('click', function () {
	            Swal.fire({
	                text: "Are you sure you would like to remove all files?",
	                icon: "warning",
	                showCancelButton: true,
	                buttonsStyling: false,
	                confirmButtonText: "Yes, remove it!",
	                cancelButtonText: "No, return",
	                customClass: {
	                    confirmButton: "btn btn-primary",
	                    cancelButton: "btn btn-active-light"
	                }
	            }).then(function (result) {
	                if (result.value) {
	                    dropzone.querySelector('.dropzone-upload').style.display = "none";
	                    dropzone.querySelector('.dropzone-remove-all').style.display = "none";
	                    myDropzone.removeAllFiles(true);
	                } else if (result.dismiss === 'cancel') {
	                    Swal.fire({
	                        text: "Your files was not removed!.",
	                        icon: "error",
	                        buttonsStyling: false,
	                        confirmButtonText: "Ok, got it!",
	                        customClass: {
	                            confirmButton: "btn btn-primary",
	                        }
	                    });
	                }
	            });
	        });

	        // On all files completed upload
	        myDropzone.on("queuecomplete", function (progress) {
	            const uploadIcons = dropzone.querySelectorAll('.dropzone-upload');
	            uploadIcons.forEach(uploadIcon => {
	                uploadIcon.style.display = "none";
	            });
	        });

	        // On all files removed
	        myDropzone.on("removedfile", function (file) {
	            if (myDropzone.files.length < 1) {
	                dropzone.querySelector('.dropzone-upload').style.display = "none";
	                dropzone.querySelector('.dropzone-remove-all').style.display = "none";
	            }
	        });
	    }

	    // Init copy link
	    /*const initCopyLink = () => {
	        // Select all copy link elements
	        const elements = table.querySelectorAll('[data-kt-filemanger-table="copy_link"]');

	        elements.forEach(el => {
	            // Define elements
	            const button = el.querySelector('button');
	            const generator = el.querySelector('[data-kt-filemanger-table="copy_link_generator"]');
	            const result = el.querySelector('[data-kt-filemanger-table="copy_link_result"]');
	            const input = el.querySelector('input');

	            // Click action
	            button.addEventListener('click', e => {
	                e.preventDefault();

	                // Reset toggle
	                generator.classList.remove('d-none');
	                result.classList.add('d-none');

	                var linkTimeout;
	                clearTimeout(linkTimeout);
	                linkTimeout = setTimeout(() => {
	                    generator.classList.add('d-none');
	                    result.classList.remove('d-none');
	                    input.select();
	                }, 2000);
	            });
	        });
	    }*/

	    // Handle move to folder
	    const handleMoveToFolder = () => {
	        const element = document.querySelector('#kt_modal_move_to_folder');
	        const form = element.querySelector('#kt_modal_move_to_folder_form');
	        const saveButton = form.querySelector('#kt_modal_move_to_folder_submit');
	        const moveModal = new bootstrap.Modal(element);

	        // Init form validation rules. For more info check the FormValidation plugin's official documentation:https://formvalidation.io/
	        var validator = FormValidation.formValidation(
	            form,
	            {
	                fields: {
	                    'move_to_folder': {
	                        validators: {
	                            notEmpty: {
	                                message: 'Please select a folder.'
	                            }
	                        }
	                    },
	                },

	                plugins: {
	                    trigger: new FormValidation.plugins.Trigger(),
	                    bootstrap: new FormValidation.plugins.Bootstrap5({
	                        rowSelector: '.fv-row',
	                        eleInvalidClass: '',
	                        eleValidClass: ''
	                    })
	                }
	            }
	        );

	        saveButton.addEventListener('click', e => {
	            e.preventDefault();

	            saveButton.setAttribute("data-kt-indicator", "on");

	            if (validator) {
	                validator.validate().then(function (status) {
	                    console.log('validated!');

	                    if (status == 'Valid') {
	                        // Simulate process for demo only
	                        setTimeout(function () {

	                            Swal.fire({
	                                text: "Are you sure you would like to move to this folder",
	                                icon: "warning",
	                                showCancelButton: true,
	                                buttonsStyling: false,
	                                confirmButtonText: "Yes, move it!",
	                                cancelButtonText: "No, return",
	                                customClass: {
	                                    confirmButton: "btn btn-primary",
	                                    cancelButton: "btn btn-active-light"
	                                }
	                            }).then(function (result) {
	                                if (result.isConfirmed) {
	                                    form.reset(); // Reset form	
	                                    moveModal.hide(); // Hide modal			

	                                    toastr.options = {
	                                        "closeButton": true,
	                                        "debug": false,
	                                        "newestOnTop": false,
	                                        "progressBar": false,
	                                        "positionClass": "toastr-top-right",
	                                        "preventDuplicates": false,
	                                        "showDuration": "300",
	                                        "hideDuration": "1000",
	                                        "timeOut": "5000",
	                                        "extendedTimeOut": "1000",
	                                        "showEasing": "swing",
	                                        "hideEasing": "linear",
	                                        "showMethod": "fadeIn",
	                                        "hideMethod": "fadeOut"
	                                    };

	                                    toastr.success('1 item has been moved.');

	                                    saveButton.removeAttribute("data-kt-indicator");
	                                } else {
	                                    Swal.fire({
	                                        text: "Your action has been cancelled!.",
	                                        icon: "error",
	                                        buttonsStyling: false,
	                                        confirmButtonText: "Ok, got it!",
	                                        customClass: {
	                                            confirmButton: "btn btn-primary",
	                                        }
	                                    });

	                                    saveButton.removeAttribute("data-kt-indicator");
	                                }
	                            });
	                        }, 500);
	                    } else {
	                        saveButton.removeAttribute("data-kt-indicator");
	                    }
	                });
	            }
	        });
	    }

	    // Count total number of items
	    const countTotalItems = () => {
	        const counter = document.getElementById('kt_file_manager_items_counter');

	        // Count total number of elements in datatable --- more info: https://datatables.net/reference/api/count()
	        counter.innerText = datatable.rows().count() + ' items';
	    }

	    // Public methods
	    return {
	        init: function () {
	            table = document.querySelector('#kt_file_manager_list');

	            if (!table) {
	                return;
	            }

	            initTemplates();
	            initDatatable();
	            initToggleToolbar();
	            handleSearchDatatable();
	            // handleDeleteRows();
	            handleNewFolder();
	            initDropzone();
	            // initCopyLink();
	            handleRename();
	            handleMoveToFolder();
	            countTotalItems();
	            KTMenu.createInstances();
	        }
	    }
	}();

	// On document ready
	KTUtil.onDOMContentLoaded(function () {
	    KTFileManagerList.init();
	});

	 
});

